import {ComputationResult} from './../computation-result';
import {Computation} from './../computation';
import {_AvailableResult} from './../available-result';

/**
 * Generated from com.dataiku.dip.eda.compute.computations.univariate.StdDev
 */
export interface StdDev extends Computation._UnivariateComputation {
    // PolyJson type
    type: 'std_dev';
}

export function isStdDev(toTest: Computation): toTest is StdDev { return 'std_dev' === toTest.type; }

export namespace StdDev {
    /**
     * Generated from com.dataiku.dip.eda.compute.computations.univariate.StdDev$StdDevResult
     */
    export interface StdDevResult extends _AvailableResult {
        value: number;

        // PolyJson type
        type: 'std_dev';
    }

    export function isStdDevResult(toTest: ComputationResult): toTest is StdDevResult { return 'std_dev' === toTest.type; }
}